export const arMenuManagementTranslations = {
  menuManagement: {
    title: 'إدارة القائمة',
    subtitle: 'إدارة عناصر القائمة والمتغيرات والإعدادات',
    tabs: {
      announcements: 'الإعلانات',
      variants: 'الخيارات',
      ingredients: 'المكونات',
      dietaryPreferences: 'التفضيلات الغذائية',
      crossSelling: 'توصيات البيع',
      zones: 'المناطق'
    },
    announcements: {
      subtitle: 'إدارة الإعلانات'
    },
    variants: {
        subtitle: 'إدارة خيارات عناصر القائمة'
    },
    ingredients: {
        subtitle: 'إدارة المكونات المستخدمة في عناصر القائمة'
    },
    ingredientGroups: 'مجموعات المكونات',
    searchIngredientsPlaceholder: 'البحث في المكونات...',
    searchGroupsPlaceholder: 'البحث في المجموعات...',
    addIngredient: 'إضافة مكون',
    addIngredientGroup: 'إضافة مجموعة مكونات',
    dietary: {
        subtitle: 'إدارة القيود والتفضيلات الغذائية لعناصر القائمة'
    },
    crossSelling: {
      subtitle: 'إدارة توصيات العناصر',
      noRelations: 'لم يتم تكوين توصيات بيع',
      noRelationsDescription: 'أضف توصيات بيع من نافذة تعديل عنصر القائمة',
      deleteMessage: 'سيؤدي هذا إلى إزالة التوصية اليدوية. قد يستمر العنصر في الظهور بناءً على الدرجات المحسوبة.',
      manual: 'يدوي',
      auto: 'تلقائي'
    },
    zones: {
      title: 'مناطق التوصيل',
      subtitle: 'إدارة مناطق التوصيل ورسومها',
      addZone: 'إضافة منطقة',
      editZone: 'تعديل المنطقة',
      deleteZone: 'حذف المنطقة',
      zoneName: 'اسم المنطقة (إنجليزي)',
      arZoneName: 'اسم المنطقة (عربي)',
      fee: 'رسوم التوصيل',
      noZones: 'لا توجد مناطق مهيأة لهذا الفرع',
      addSuccess: 'تمت إضافة المنطقة بنجاح',
      updateSuccess: 'تم تحديث المنطقة بنجاح',
      deleteSuccess: 'تم حذف المنطقة بنجاح',
      deleteConfirmation: 'هل أنت متأكد من حذف هذه المنطقة؟',
      zoneNameRequired: 'اسم المنطقة مطلوب',
      arZoneNameRequired: 'اسم المنطقة بالعربية مطلوب',
      feeInvalid: 'يجب أن تكون الرسوم 0 أو أكثر',
      zoneNamePlaceholder: 'مثال: وسط المدينة',
      arZoneNamePlaceholder: 'مثال: City Center'
    }
  }
};
